import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {ToolItem} from '@pb/kit-component-tools-ribbon';

import type {SelectionType, SetSelectionType} from '@pb/kit-component-selection';


export type Props = {
    selection: SelectionType,
    totalCount: number,
    setSelection: SetSelectionType,
};
export const noSelected = (
    totalCount: number,
    {ids, inverted}: SelectionType,
) => (ids.length === 0 && !inverted) || (ids.length === totalCount && inverted);

export const DeselectAllView = ({selection, totalCount, setSelection}: Props) => {
    const deselectAll = () => {
        setSelection({
            inverted: false,
            ids: [],
        });
    };

    return !noSelected(totalCount, selection) ? (
        <ToolItem>
            <FlatButton
                disabled={false}
                onClick={deselectAll}>
                <strong>Deselect All</strong>
            </FlatButton>
        </ToolItem>
    ) : null;
};
